import { Component, input, output } from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import {
  MachTier,
  MedallionBannerAriaLabel
} from '../../models/medallion-banner.interfaces';
import { Priority, Status } from './models/status.interfaces';

@Component({
  selector: 'idp-status',
  standalone: true,
  imports: [],
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss'
})
export class StatusComponent {
  content = input<Status>({} as Status);
  ariaLabel = input<MedallionBannerAriaLabel>({} as MedallionBannerAriaLabel);
  redirect = output<Link>();

  get360AndSkyPriority(tier: MachTier, priority: Priority) {
    return (
      (tier.name === '360' ? '--360' : '') +
      (priority.label !== '' && priority.url !== '' ? '--skypriority' : '')
    );
  }

  getAccountStatus() {
    const className =
      'skymiles-medallion-banner__status skymiles-medallion-banner__status--' +
      this.content().tier.name +
      ' skymiles-medallion-banner__status__height' +
      this.get360AndSkyPriority(this.content().tier, this.content().priority) +
      (this.content().tier.title
        ? ''
        : ' skymiles-medallion-banner__status__height--tier-title');

    return className;
  }
}
